import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';

import moment from 'moment';
import getLocale from '../../../i18n/getLocale';

class FlightReportLegAddTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      updated: false,
      modal: false,
      modal_flight_following: false,
      id: null,
      staff_id: null,
      duty_id: null,
      flight_report_id: null,
      departure_location_id: null,
      arrival_location_id: null,
      leg_number: null,
      takeoff_time_scheduled: null,
      total_time_scheduled: null,
      engine_start_time: null,
      takeoff_time: null,
      landing_time: null,
      engine_shutoff_time: null,
      takeoff_land_time: null,
      total_time: '00:00:00',
      navigation_time: '00:00:00',
      ifr_time: '00:00:00',
      night_time: '00:00:00',
      day_landings: 0,
      night_landings: 0,
      starts: null,
      pax: 0,
      payload: 0,
      external_load_long_line: 0,
      external_load_short_line: 0,
      fuel_start: 0,
      fuel_end: 0,
      ptbr_code_id: null,
      ptbr_operation_id: null,
      ptbr_external_load_id: null,
      delay_time: null,
      delay_departure: null,
      locations_select: [],
      ptbr_codes_select: [],
      ptbr_operations_select: [],
      ptbr_external_loads_select: [],
      duties_select: [],
      staffs_select: [],
      flight_report_leg_edit: {},
      flight_report_leg_edit_staffs: {},
      style: {},
      edited: false,
      handle_edited: false,
    };

    this.editMobile = this.editMobile.bind(this);
    this.delete = this.delete.bind(this);
    this.addStaff = this.addStaff.bind(this);
    this.deleteStaff = this.deleteStaff.bind(this);
    this.diffFlight = this.diffFlight.bind(this);
    this.diffTotalTime = this.diffTotalTime.bind(this);
    this.delayFlight = this.delayFlight.bind(this);
    this.delayTotalTime = this.delayTotalTime.bind(this);
    this.calcTimeFromMs = this.calcTimeFromMs.bind(this);

    this.locale = getLocale();
    this.autoFillTime = this.autoFillTime.bind(this);
    this.cleanLeg = this.cleanLeg.bind(this);
    this.propsHandling = this.propsHandling.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change['handle_edited'] = true;
    change['edited'] = true;
    change[name] = event.target.value;
    if (name === 'takeoff_time') {
      this.diffFlight(event.target.value, this.state.landing_time, change);
      this.delayFlight(event.target.value, this.state.takeoff_time_scheduled, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, event.target.value, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'landing_time') {
      this.diffFlight(this.state.takeoff_time, event.target.value, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, event.target.value, this.state.start_parameter_total, change);
    } else if (name === 'engine_start_time') {
      this.diffTotalTime(event.target.value, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'engine_shutoff_time') {
      this.diffTotalTime(this.state.engine_start_time, event.target.value, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'takeoff_time_scheduled') {
      this.delayFlight(this.state.takeoff_time, event.target.value, change);
    } else if (name === 'total_time_scheduled') {
      this.delayTotalTime(event.target.value, this.state.takeoff_land_time, change);
    } else {
      this.setState(change);
    }
  }

  handleSelectChange(name, event) {
    var change = {};
    change['handle_edited'] = true;
    change['edited'] = true;
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    change['handle_edited'] = true;
    change['edited'] = true;
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  // LM
  componentDidMount() {
    this.propsHandling(this.props);
  
    var flight_report_id = this.props.flight_report_id;
    let flight_report_legs_new_all = JSON.parse(localStorage.getItem("cached_flight_report_legs_states_new_by_id")) || {};
    let flight_report_legs_new = flight_report_legs_new_all[flight_report_id] || [];
  
    this.setState({
      flight_report_legs_new: flight_report_legs_new
    });
  }  

  componentDidUpdate(prevProps, prevState) {
    if (this.state.handle_edited) {
      var cached_flight_report_legs_states_new_by_id = JSON.parse(localStorage.getItem("cached_flight_report_legs_states_new_by_id")) || {};
  
      if (!cached_flight_report_legs_states_new_by_id[this.props.flight_report_id]) {
        cached_flight_report_legs_states_new_by_id[this.props.flight_report_id] = [];
      }
  
      cached_flight_report_legs_states_new_by_id[this.props.flight_report_id][this.props.flight_report_legs_states_new_index] = {
        'id': this.state.id,
        'takeoff_time_scheduled': this.state.takeoff_time_scheduled,
        'total_time_scheduled': this.state.total_time_scheduled,
        'engine_start_time': this.state.engine_start_time,
        'takeoff_time': this.state.takeoff_time,
        'landing_time': this.state.landing_time,
        'engine_shutoff_time': this.state.engine_shutoff_time,
        'takeoff_land_time': this.state.takeoff_land_time,
        'flight_following_engine_start_time': this.state.flight_following_engine_start_time,
        'flight_following_takeoff_time': this.state.flight_following_takeoff_time,
        'flight_following_landing_time': this.state.flight_following_landing_time,
        'flight_following_engine_shutoff_time': this.state.flight_following_engine_shutoff_time,
        'total_time': this.state.total_time,
        'navigation_time': this.state.navigation_time,
        'ifr_time': this.state.ifr_time,
        'night_time': this.state.night_time,
        'start_parameter_total': this.state.start_parameter_total,
        'xml': this.state.xml,
        'external_load': this.state.external_load,
        'flight_report_id': this.state.flight_report_id,
        'departure_location_id': this.state.departure_location_id,
        'arrival_location_id': this.state.arrival_location_id,
        'day_landings': this.state.day_landings,
        'night_landings': this.state.night_landings,
        'starts': this.state.starts,
        'pax': this.state.pax,
        'payload': this.state.payload,
        'external_load_long_line': this.state.external_load_long_line,
        'external_load_short_line': this.state.external_load_short_line,
        'fuel_start': this.state.fuel_start,
        'fuel_end': this.state.fuel_end,
        'ptbr_code_id': this.state.ptbr_code_id,
        'ptbr_operation_id': this.state.ptbr_operation_id,
        'ptbr_external_load_id': this.state.ptbr_external_load_id,
        'delay_departure': this.state.delay_departure,
        'delay_time': this.state.delay_time,
        'leg_number': this.state.leg_number,
        'edited': true,
      };
  
      this.setState({ handle_edited: false });
  
      localStorage.setItem("cached_flight_report_legs_states_new_by_id", JSON.stringify(cached_flight_report_legs_states_new_by_id));
    }
  
    if (this.props.deleting === true && this.state.loaded === true) {
      this.propsHandling(this.props);
      this.props.setDeleteFalse();
    }
  }  

  componentWillReceiveProps(newProps) {
    if((this.state.loaded === false || newProps.updated === 1)) {
      this.propsHandling(newProps);
      if(newProps.flight_report_leg_edit.edited) {
        this.setState({
          flight_report_leg_edit_staffs: newProps.flight_report_leg_edit_staffs,
          locations_select: newProps.locations_select,
          ptbr_codes_select: newProps.ptbr_codes_select,
          ptbr_operations_select: newProps.ptbr_operations_select,
          ptbr_external_loads_select: newProps.ptbr_external_loads_select,
          staffs_select: newProps.staffs_select,
          duties_select: newProps.duties_select,
          style: newProps.style,
          date: newProps.date,
          id: newProps.flight_report_leg_edit.id,
          flight_report_id: newProps.flight_report_leg_edit.flight_report_id,
          departure_location_id: newProps.flight_report_leg_edit.departure_location_id,
          arrival_location_id: newProps.flight_report_leg_edit.arrival_location_id,
          takeoff_time_scheduled: newProps.flight_report_leg_edit.takeoff_time_scheduled,
          total_time_scheduled: newProps.flight_report_leg_edit.total_time_scheduled,
          engine_start_time: newProps.flight_report_leg_edit.engine_start_time,
          takeoff_time: newProps.flight_report_leg_edit.takeoff_time,
          landing_time: newProps.flight_report_leg_edit.landing_time,
          engine_shutoff_time: newProps.flight_report_leg_edit.engine_shutoff_time,
          takeoff_land_time: newProps.flight_report_leg_edit.takeoff_land_time,
          flight_following_engine_start_time: newProps.flight_report_leg_edit.flight_following_engine_start_time,
          flight_following_takeoff_time: newProps.flight_report_leg_edit.flight_following_takeoff_time,
          flight_following_landing_time: newProps.flight_report_leg_edit.flight_following_landing_time,
          flight_following_engine_shutoff_time: newProps.flight_report_leg_edit.flight_following_engine_shutoff_time,
          total_time: newProps.flight_report_leg_edit.total_time,
          navigation_time: newProps.flight_report_leg_edit.navigation_time,
          ifr_time: newProps.flight_report_leg_edit.ifr_time,
          night_time: newProps.flight_report_leg_edit.night_time,
          day_landings: newProps.flight_report_leg_edit.day_landings,
          night_landings: newProps.flight_report_leg_edit.night_landings,
          starts: newProps.flight_report_leg_edit.starts,
          pax: newProps.flight_report_leg_edit.pax,
          payload: newProps.flight_report_leg_edit.payload,
          external_load_long_line: newProps.flight_report_leg_edit.external_load_long_line,
          external_load_short_line: newProps.flight_report_leg_edit.external_load_short_line,
          fuel_start: newProps.flight_report_leg_edit.fuel_start,
          fuel_end: newProps.flight_report_leg_edit.fuel_end,
          ptbr_code_id: newProps.flight_report_leg_edit.ptbr_code_id,
          ptbr_operation_id: newProps.flight_report_leg_edit.ptbr_operation_id,
          ptbr_external_load_id: newProps.flight_report_leg_edit.ptbr_external_load_id,
          delay_departure: newProps.flight_report_leg_edit.delay_departure,
          delay_time: newProps.flight_report_leg_edit.delay_time,
          leg_number: newProps.flight_report_leg_edit.leg_number,
          start_parameter_total: newProps.flight_report_leg_edit.start_parameter_total,
          xml: newProps.flight_report_leg_edit.xml,
          external_load: newProps.flight_report_leg_edit.external_load,
          loaded: true,
          updated: false,
          edited: true,
        });
      } else {

        let takeoff_time_scheduled = newProps.flight_report_leg_edit.takeoff_time_scheduled_str; if (takeoff_time_scheduled === null) takeoff_time_scheduled = '';
        let total_time_scheduled = newProps.flight_report_leg_edit.total_time_scheduled; if (total_time_scheduled === null) total_time_scheduled = '';
        let engine_start_time = newProps.flight_report_leg_edit.engine_start_time_str; if (engine_start_time === null) engine_start_time = '';
        let takeoff_time = newProps.flight_report_leg_edit.takeoff_time_str; if (takeoff_time === null) takeoff_time = '';
        let landing_time = newProps.flight_report_leg_edit.landing_time_str; if (landing_time === null) landing_time = '';
        let engine_shutoff_time = newProps.flight_report_leg_edit.engine_shutoff_time_str; if (engine_shutoff_time === null) engine_shutoff_time = '';
        let takeoff_land_time = newProps.flight_report_leg_edit.takeoff_land_time; if (takeoff_land_time === null) takeoff_land_time = '';
        let flight_following_engine_start_time = newProps.flight_report_leg_edit.flight_following_engine_start_time_str; if (flight_following_engine_start_time === null) flight_following_engine_start_time = '';
        let flight_following_takeoff_time = newProps.flight_report_leg_edit.flight_following_takeoff_time_str; if (flight_following_takeoff_time === null) flight_following_takeoff_time = '';
        let flight_following_landing_time = newProps.flight_report_leg_edit.flight_following_landing_time_str; if (flight_following_landing_time === null) flight_following_landing_time = '';
        let flight_following_engine_shutoff_time = newProps.flight_report_leg_edit.flight_following_engine_shutoff_time_str; if (flight_following_engine_shutoff_time === null) flight_following_engine_shutoff_time = '';
        let total_time = newProps.flight_report_leg_edit.total_time; if (total_time === null) total_time = '';
        let navigation_time = newProps.flight_report_leg_edit.navigation_time; if (navigation_time === null) navigation_time = '';
        let ifr_time = newProps.flight_report_leg_edit.ifr_time; if (ifr_time === null) ifr_time = '';
        let night_time = newProps.flight_report_leg_edit.night_time; if (night_time === null) night_time = '';
  
        let leg_data = {
            flight_report_leg_edit_staffs: newProps.flight_report_leg_edit_staffs,
            locations_select: newProps.locations_select,
            ptbr_codes_select: newProps.ptbr_codes_select,
            ptbr_operations_select: newProps.ptbr_operations_select,
            ptbr_external_loads_select: newProps.ptbr_external_loads_select,
            staffs_select: newProps.staffs_select,
            duties_select: newProps.duties_select,
            style: newProps.style,
            date: newProps.date,
            id: newProps.flight_report_leg_edit.id,
            flight_report_id: newProps.flight_report_leg_edit.flight_report_id,
            departure_location_id: newProps.flight_report_leg_edit.departure_location_id,
            arrival_location_id: newProps.flight_report_leg_edit.arrival_location_id,
            takeoff_time_scheduled: takeoff_time_scheduled,
            total_time_scheduled: total_time_scheduled,
            engine_start_time: engine_start_time,
            takeoff_time: takeoff_time,
            landing_time: landing_time,
            engine_shutoff_time: engine_shutoff_time,
            takeoff_land_time: takeoff_land_time,
            flight_following_engine_start_time: flight_following_engine_start_time,
            flight_following_takeoff_time: flight_following_takeoff_time,
            flight_following_landing_time: flight_following_landing_time,
            flight_following_engine_shutoff_time: flight_following_engine_shutoff_time,
            total_time: total_time,
            navigation_time: navigation_time,
            ifr_time: ifr_time,
            night_time: night_time,
            day_landings: newProps.flight_report_leg_edit.day_landings,
            night_landings: newProps.flight_report_leg_edit.night_landings,
            starts: newProps.flight_report_leg_edit.starts,
            pax: newProps.flight_report_leg_edit.pax,
            payload: newProps.flight_report_leg_edit.payload,
            external_load_long_line: newProps.flight_report_leg_edit.external_load_long_line,
            external_load_short_line: newProps.flight_report_leg_edit.external_load_short_line,
            fuel_start: newProps.flight_report_leg_edit.fuel_start,
            fuel_end: newProps.flight_report_leg_edit.fuel_end,
            ptbr_code_id: newProps.flight_report_leg_edit.ptbr_code_id,
            ptbr_operation_id: newProps.flight_report_leg_edit.ptbr_operation_id,
            ptbr_external_load_id: newProps.flight_report_leg_edit.ptbr_external_load_id,
            delay_departure: newProps.flight_report_leg_edit.delay_departure,
            delay_time: newProps.flight_report_leg_edit.delay_time,
            leg_number: newProps.flight_report_leg_edit.leg_number,
            start_parameter_total: newProps.start_parameter_total,
            xml: newProps.xml,
            external_load: newProps.external_load,
            loaded: true,
            updated: false,
            edited: false,
        };
        this.setState(leg_data);

      }
    }
  }

  propsHandling (props) {
    if(props.flight_report_leg_edit.edited) {
      this.setState({
        flight_report_leg_edit_staffs: props.flight_report_leg_edit_staffs,
        locations_select: props.locations_select,
        ptbr_codes_select: props.ptbr_codes_select,
        ptbr_operations_select: props.ptbr_operations_select,
        ptbr_external_loads_select: props.ptbr_external_loads_select,
        staffs_select: props.staffs_select,
        duties_select: props.duties_select,
        style: props.style,
        date: props.date,
        id: props.flight_report_leg_edit.id,
        flight_report_id: props.flight_report_leg_edit.flight_report_id,
        departure_location_id: props.flight_report_leg_edit.departure_location_id,
        arrival_location_id: props.flight_report_leg_edit.arrival_location_id,
        takeoff_time_scheduled: props.flight_report_leg_edit.takeoff_time_scheduled,
        total_time_scheduled: props.flight_report_leg_edit.total_time_scheduled,
        engine_start_time: props.flight_report_leg_edit.engine_start_time,
        takeoff_time: props.flight_report_leg_edit.takeoff_time,
        landing_time: props.flight_report_leg_edit.landing_time,
        engine_shutoff_time: props.flight_report_leg_edit.engine_shutoff_time,
        takeoff_land_time: props.flight_report_leg_edit.takeoff_land_time,
        flight_following_engine_start_time: props.flight_report_leg_edit.flight_following_engine_start_time,
        flight_following_takeoff_time: props.flight_report_leg_edit.flight_following_takeoff_time,
        flight_following_landing_time: props.flight_report_leg_edit.flight_following_landing_time,
        flight_following_engine_shutoff_time: props.flight_report_leg_edit.flight_following_engine_shutoff_time,
        total_time: props.flight_report_leg_edit.total_time,
        navigation_time: props.flight_report_leg_edit.navigation_time,
        ifr_time: props.flight_report_leg_edit.ifr_time,
        night_time: props.flight_report_leg_edit.night_time,
        day_landings: props.flight_report_leg_edit.day_landings,
        night_landings: props.flight_report_leg_edit.night_landings,
        starts: props.flight_report_leg_edit.starts,
        pax: props.flight_report_leg_edit.pax,
        payload: props.flight_report_leg_edit.payload,
        external_load_long_line: props.flight_report_leg_edit.external_load_long_line,
        external_load_short_line: props.flight_report_leg_edit.external_load_short_line,
        fuel_start: props.flight_report_leg_edit.fuel_start,
        fuel_end: props.flight_report_leg_edit.fuel_end,
        ptbr_code_id: props.flight_report_leg_edit.ptbr_code_id,
        ptbr_operation_id: props.flight_report_leg_edit.ptbr_operation_id,
        ptbr_external_load_id: props.flight_report_leg_edit.ptbr_external_load_id,
        delay_departure: props.flight_report_leg_edit.delay_departure,
        delay_time: props.flight_report_leg_edit.delay_time,
        leg_number: props.flight_report_leg_edit.leg_number,
        start_parameter_total: props.flight_report_leg_edit.start_parameter_total,
        xml: props.flight_report_leg_edit.xml,
        external_load: props.flight_report_leg_edit.external_load,
        loaded: true,
        updated: false,
        edited: true,
      });
    } else {
      let takeoff_time_scheduled = props.flight_report_leg_edit.takeoff_time_scheduled_str; if (takeoff_time_scheduled === null) takeoff_time_scheduled = '';
      let total_time_scheduled = props.flight_report_leg_edit.total_time_scheduled; if (total_time_scheduled === null) total_time_scheduled = '';
      let engine_start_time = props.flight_report_leg_edit.engine_start_time_str; if (engine_start_time === null) engine_start_time = '';
      let takeoff_time = props.flight_report_leg_edit.takeoff_time_str; if (takeoff_time === null) takeoff_time = '';
      let landing_time = props.flight_report_leg_edit.landing_time_str; if (landing_time === null) landing_time = '';
      let engine_shutoff_time = props.flight_report_leg_edit.engine_shutoff_time_str; if (engine_shutoff_time === null) engine_shutoff_time = '';
      let takeoff_land_time = props.flight_report_leg_edit.takeoff_land_time; if (takeoff_land_time === null) takeoff_land_time = '';
      let flight_following_engine_start_time = props.flight_report_leg_edit.flight_following_engine_start_time_str; if (flight_following_engine_start_time === null) flight_following_engine_start_time = '';
      let flight_following_takeoff_time = props.flight_report_leg_edit.flight_following_takeoff_time_str; if (flight_following_takeoff_time === null) flight_following_takeoff_time = '';
      let flight_following_landing_time = props.flight_report_leg_edit.flight_following_landing_time_str; if (flight_following_landing_time === null) flight_following_landing_time = '';
      let flight_following_engine_shutoff_time = props.flight_report_leg_edit.flight_following_engine_shutoff_time_str; if (flight_following_engine_shutoff_time === null) flight_following_engine_shutoff_time = '';
      let total_time = props.flight_report_leg_edit.total_time; if (total_time === null) total_time = '';
      let navigation_time = props.flight_report_leg_edit.navigation_time; if (navigation_time === null) navigation_time = '';
      let ifr_time = props.flight_report_leg_edit.ifr_time; if (ifr_time === null) ifr_time = '';
      let night_time = props.flight_report_leg_edit.night_time; if (night_time === null) night_time = '';

      this.setState({
        flight_report_leg_edit_staffs: props.flight_report_leg_edit_staffs,
        locations_select: props.locations_select,
        ptbr_codes_select: props.ptbr_codes_select,
        ptbr_operations_select: props.ptbr_operations_select,
        ptbr_external_loads_select: props.ptbr_external_loads_select,
        staffs_select: props.staffs_select,
        duties_select: props.duties_select,
        style: props.style,
        date: props.date,
        id: props.flight_report_leg_edit.id,
        flight_report_id: props.flight_report_leg_edit.flight_report_id,
        departure_location_id: props.flight_report_leg_edit.departure_location_id,
        arrival_location_id: props.flight_report_leg_edit.arrival_location_id,
        takeoff_time_scheduled: takeoff_time_scheduled,
        total_time_scheduled: total_time_scheduled,
        engine_start_time: engine_start_time,
        takeoff_time: takeoff_time,
        landing_time: landing_time,
        engine_shutoff_time: engine_shutoff_time,
        takeoff_land_time: takeoff_land_time,
        flight_following_engine_start_time: flight_following_engine_start_time,
        flight_following_takeoff_time: flight_following_takeoff_time,
        flight_following_landing_time: flight_following_landing_time,
        flight_following_engine_shutoff_time: flight_following_engine_shutoff_time,
        total_time: total_time,
        navigation_time: navigation_time,
        ifr_time: ifr_time,
        night_time: night_time,
        day_landings: props.flight_report_leg_edit.day_landings,
        night_landings: props.flight_report_leg_edit.night_landings,
        starts: props.flight_report_leg_edit.starts,
        pax: props.flight_report_leg_edit.pax,
        payload: props.flight_report_leg_edit.payload,
        external_load_long_line: props.flight_report_leg_edit.external_load_long_line,
        external_load_short_line: props.flight_report_leg_edit.external_load_short_line,
        fuel_start: props.flight_report_leg_edit.fuel_start,
        fuel_end: props.flight_report_leg_edit.fuel_end,
        ptbr_code_id: props.flight_report_leg_edit.ptbr_code_id,
        ptbr_operation_id: props.flight_report_leg_edit.ptbr_operation_id,
        ptbr_external_load_id: props.flight_report_leg_edit.ptbr_external_load_id,
        delay_departure: props.flight_report_leg_edit.delay_departure,
        delay_time: props.flight_report_leg_edit.delay_time,
        leg_number: props.flight_report_leg_edit.leg_number,
        start_parameter_total: props.start_parameter_total,
        xml: props.xml,
        external_load: props.external_load,
        loaded: true,
        updated: false,
        edited: false,
      });

    }

  }

  autoFillTime (name, value) {
    var now = moment(new Date());
    now = now.format("HH:mm");

    if(value !== null) {
      now = value;
    }

    var change = {};
    change[name] = now;
    change['handle_edited'] = true;
    change['edited'] = true;

    if (name === 'takeoff_time') {
      this.diffFlight(now, this.state.landing_time, change);
      this.delayFlight(now, this.state.takeoff_scheduled, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, now, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'landing_time') {
      this.diffFlight(this.state.takeoff_time, now, change);
      this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, now, this.state.start_parameter_total, change);
    } else if (name === 'engine_start_time') {
      this.diffTotalTime(now, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'engine_shutoff_time') {
      this.diffTotalTime(this.state.engine_start_time, now, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
    } else if (name === 'takeoff_scheduled') {
      this.delayFlight(this.state.takeoff_time, now, change);
    } else if (name === 'total_time_preview') {
      this.delayTotalTime(now, this.state.takeoff_land_time, change);
    } else {
      this.setState(change);
    }
  }

  diffFlight(takeoff_time, landing_time, change) {
    if (takeoff_time && landing_time && takeoff_time !== '' && landing_time !== '') {
      takeoff_time = this.state.date + ' ' + takeoff_time;
      landing_time = this.state.date + ' ' + landing_time;

      takeoff_time = moment(takeoff_time, "DD/MM/YYYY HH:mm:ss");
      landing_time = moment(landing_time, "DD/MM/YYYY HH:mm:ss");

      if (takeoff_time > landing_time) {
        landing_time.add(1, 'd');
      }

      takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss"));
      landing_time = new Date(landing_time.format("YYYY-MM-DD HH:mm:ss"));
      let diffTime = Math.abs(landing_time.getTime() - takeoff_time.getTime());
      if (landing_time > takeoff_time) {
        change['takeoff_land_time'] = this.calcTimeFromMs(diffTime);
        change['navigation_time'] = this.calcTimeFromMs(diffTime);
      } else {
        change['takeoff_land_time'] = '00:00';
        change['navigation_time'] = '00:00';
      }
    } else {
      change['takeoff_land_time'] = '00:00';
      change['navigation_time'] = '00:00';
    }
    this.delayTotalTime(this.state.total_time_scheduled, change['takeoff_land_time'], change);
  }

  diffTotalTime(engine_start_time, engine_shutoff_time, takeoff_time, landing_time, start_parameter_total, change) {
    let start = null;
    if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
      start = engine_start_time;
    } else if (start_parameter_total !== null) {
      start = start_parameter_total.substring(11);
    }

    if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
      start = engine_start_time;
    }

    let finish = null;
    if (landing_time !== null && landing_time !== '' && typeof landing_time !== 'undefined') {
      finish = landing_time;
    }
    if (engine_shutoff_time !== null && engine_shutoff_time !== '' && typeof engine_shutoff_time !== 'undefined') {
      finish = engine_shutoff_time;
    }

    if(start && finish) {
      start = this.state.date + ' ' + start;
      finish = this.state.date + ' ' + finish;

      start = moment(start, "DD/MM/YYYY HH:mm:ss");
      finish = moment(finish, "DD/MM/YYYY HH:mm:ss");

      if (start > finish) {
        finish.add(1, 'd');
      }

      start = new Date(start.format("YYYY-MM-DD HH:mm:ss"));
      finish = new Date(finish.format("YYYY-MM-DD HH:mm:ss"));

      let diffTime = Math.abs(finish.getTime() - start.getTime());
      if (finish > start) {
        change['total_time'] = this.calcTimeFromMs(diffTime);
      } else {
        change['total_time'] = '00:00';
      }
      this.setState(change);
    } else {
      change['total_time'] = '00:00';
      this.setState(change);
    }
  }

  delayFlight(takeoff_time, takeoff_time_scheduled, change) {
    if(takeoff_time_scheduled) {
      takeoff_time = this.state.date + ' ' + takeoff_time;
      takeoff_time_scheduled = this.state.date + ' ' + takeoff_time_scheduled;

      takeoff_time = moment(takeoff_time, "DD/MM/YYYY HH:mm:ss");
      takeoff_time_scheduled = moment(takeoff_time_scheduled, "DD/MM/YYYY HH:mm:ss");

      let diff_hours = takeoff_time_scheduled.diff(takeoff_time, 'hours');

      if (takeoff_time < takeoff_time_scheduled && diff_hours > 12) {
        takeoff_time.add(1, 'd');
      }

      takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss"));
      takeoff_time_scheduled = new Date(takeoff_time_scheduled.format("YYYY-MM-DD HH:mm:ss"));
      let diffTime = Math.abs(takeoff_time.getTime() - takeoff_time_scheduled.getTime());
      if (takeoff_time > takeoff_time_scheduled) {
        change['delay_departure'] = this.calcTimeFromMs(diffTime);
      } else {
        change['delay_departure'] = '00:00';
      }
    } else {
      change['delay_departure'] = '00:00';
    }
    this.setState(change);
  }

  delayTotalTime(total_time_scheduled, takeoff_land_time, change) {
    if(takeoff_land_time) {
      takeoff_land_time = moment().format("YYYY-MM-DD") + ' ' + takeoff_land_time;
      total_time_scheduled = moment().format("YYYY-MM-DD") + ' ' + total_time_scheduled;

      takeoff_land_time = new Date(takeoff_land_time);
      total_time_scheduled = new Date(total_time_scheduled);
      let diffTime = Math.abs(takeoff_land_time.getTime() - total_time_scheduled.getTime());
      if (takeoff_land_time > total_time_scheduled) {
        change['delay_time'] = this.calcTimeFromMs(diffTime);
      } else {
        change['delay_time'] = '00:00';
      }
    }
    this.setState(change);
  }

  calcTimeFromMs(diffTime) {
    diffTime = diffTime/1000;
    var secs = diffTime % 60;
    diffTime = (diffTime - secs) / 60;
    var mins = diffTime % 60;
    var hrs = (diffTime - mins) / 60;
    if (secs < 10) { secs = '0' + secs; }
    if (mins < 10) { mins = '0' + mins; }
    if (hrs < 10) { hrs = '0' + hrs; }
    return hrs + ':' + mins + ':' + secs ;
  }

  // Fetch salvando a edição
  editMobile(event) {
    event.preventDefault();
    this.edit();
  }

  delete () {
    if(window.confirm('Tem certeza que deseja excluir este trecho?')) {
      this.props.setParentState(this.props.flight_report_legs_states_new_index)
    }
  }

  addStaff(event) {
    event.preventDefault();
    if(navigator.onLine) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        flight_report_leg_id: this.state.id,
        staff_id: this.state.staff_id,
        duty_id: this.state.duty_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/trecho/tripulante', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    } else {
      window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
    }    
  }

  deleteStaff(id) {
    if(navigator.onLine) {
      if(window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.removerTripulanteDoTrecho)) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          id: id,
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/relatorio/voo/trecho/tripulante', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    } else {
      window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
    }

  }

  cleanLeg(id) {
    var flight_report_leg_ids = [id];
    if (localStorage.getItem("cached_flight_report_legs_states_by_id")){
      this.props.handleAlert('', '', 'open');
      var cached_flight_report_legs_states_by_id = localStorage.getItem("cached_flight_report_legs_states_by_id");
      cached_flight_report_legs_states_by_id = JSON.parse(cached_flight_report_legs_states_by_id);
      var new_cached_flight_report_legs_states_by_id = {};
      {Object.keys(cached_flight_report_legs_states_by_id).map(function(k) {
        var frl_by_id = cached_flight_report_legs_states_by_id[k];
        if(!flight_report_leg_ids.includes(frl_by_id.id)) {
          new_cached_flight_report_legs_states_by_id[frl_by_id.id] = frl_by_id;
        }
      })}
      localStorage.setItem("cached_flight_report_legs_states_by_id", JSON.stringify(new_cached_flight_report_legs_states_by_id));
      var responseJson = {
        data: {},
        status: 'success',
        message: this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.limparTrecho,
      };
      this.props.updateData(responseJson);
    }
  }

  render() {
    var self = this;
    var style = {};
    if(self.state.edited) {
      style = {background: '#f3e5c9'};
    }
    return (
  <tr style={style}>
    <td style={{width: '200px', whiteSpace: 'nowrap', textAlign: 'center',}}>
        <button type="button" className="btn btn-info btn-sm button-inline" onClick={() => {this.setState({modal_flight_following: true})}}><i className="fa fa-clock-o"></i></button>
        <button type="button" className="btn btn-danger button-inline btn-sm" onClick={() => {this.delete()}}><i className="fa fa-close"></i></button>
    </td>
    <td>{this.state.leg_number}</td>
    <td>
      <RequestApi ref={'request_api'} />
      <Select
        className="form-field-name"
        style={this.state.style.select_places}
        name="departure_location_id"
        value={this.state.departure_location_id}
        searchable={true}
        placeholder={''}
        onChange={this.handleSelectChange.bind(this, 'departure_location_id')}
        options={this.state.locations_select}

      />
    </td>
    <td>
      <Select
        className="form-field-name"
        style={this.state.style.select_places}
        name="arrival_location_id"
        value={this.state.arrival_location_id}
        searchable={true}
        placeholder={''}
        onChange={this.handleSelectChange.bind(this, 'arrival_location_id')}
        options={this.state.locations_select}

      />
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.engine_start_time}  maskChar={null} name="engine_start_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'engine_start_time')} placeholder=""/>
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.takeoff_time}  maskChar={null} name="takeoff_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'takeoff_time')} placeholder=""/>
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.landing_time}  maskChar={null} name="landing_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'landing_time')} placeholder=""/>
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.engine_shutoff_time}  maskChar={null} name="engine_shutoff_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'engine_shutoff_time')} placeholder=""/>
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.takeoff_land_time}  maskChar={null} name="takeoff_land_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'takeoff_land_time')} placeholder="" disabled />
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.total_time}  maskChar={null} name="total_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'total_time')} placeholder="" disabled />
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.navigation_time}  maskChar={null} name="navigation_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'navigation_time')} placeholder=""  />
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.ifr_time}  maskChar={null} name="ifr_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'ifr_time')} placeholder=""  />
    </td>
    <td>
      <InputMask style={this.state.style.input_hour} value={this.state.night_time}  maskChar={null} name="night_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'night_time')} placeholder=""  />
    </td>
    <td>
      <input style={this.state.style.input_number} type="number" value={this.state.day_landings} name="day_landings " className="form-control" onChange={this.handleChange.bind(this, 'day_landings')} placeholder=""  />
    </td>
    <td>
      <input style={this.state.style.input_number} type="number" value={this.state.night_landings} name="night_landings " className="form-control" onChange={this.handleChange.bind(this, 'night_landings')} placeholder=""  />
    </td>
    <td>
      <input style={this.state.style.input_number} type="number" value={this.state.starts} name="starts " className="form-control" onChange={this.handleChange.bind(this, 'starts')} placeholder="" />
    </td>
    <td>
      <input style={this.state.style.input_number} type="number" value={this.state.pax} name="pax " className="form-control" onChange={this.handleChange.bind(this, 'pax')} placeholder=""  />
    </td>
    <td>
      <input style={this.state.style.input_number} type="number" value={this.state.payload} name="payload " className="form-control" onChange={this.handleChange.bind(this, 'payload')} placeholder=""  />
    </td>
    {this.state.external_load == 1 ? 
      <td>
        <br/>
        <Toggle
          checked={this.state.external_load_long_line}
          aria-label='No label tag'
          name="external_load_long_line"
          onChange={this.handleToggleChange.bind(this, 'external_load_long_line')} />
      </td>

    : ''
    }
    {this.state.external_load == 1 ? 
      <td>
        <br/>
        <Toggle
          checked={this.state.external_load_short_line}
          aria-label='No label tag'
          name="external_load_short_line"
          onChange={this.handleToggleChange.bind(this, 'external_load_short_line')} />
      </td>
    : ''
    }
    <td>
      <input style={this.state.style.input_number} type="number" value={this.state.fuel_start} name="fuel_start " className="form-control" onChange={this.handleChange.bind(this, 'fuel_start')} placeholder=""  />
    </td>
    <td>
      <input style={this.state.style.input_number} type="number" value={this.state.fuel_end} name="fuel_end " className="form-control" onChange={this.handleChange.bind(this, 'fuel_end')} placeholder=""  />
    </td>
    {this.state.xml == 1 ? 
      <td>
        <Select
          className="form-field-name"
          name="ptbr_code_id"
          value={this.state.ptbr_code_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'ptbr_code_id')}
          options={this.state.ptbr_codes_select}
          style={this.state.style.select_operation}
        />
      </td>
    : ''
    }
    <td style={{width: '200px', whiteSpace: 'nowrap', textAlign: 'center'}}>
      <button type="button" className="btn btn-danger button-inline btn-sm" onClick={() => {this.delete()}}><i className="fa fa-fw fa-close"></i></button>
    </td>
    <Modal show={this.state.modal_flight_following} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
        <Modal.Header>
          <h4 className="pull-left">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloEdicaoTrecho} - {this.state.leg_number}</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={() => self.setState({modal_flight_following: false})}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <h4>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Partida}</h4>
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th className="text-center col-md-2">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Horario}</th>
                  {/* <th className="text-center col-md-2">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Following}</th> */}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="row">
                      <div className="col-md-6">
                        <InputMask value={this.state.engine_start_time} maskChar={null} name="engine_start_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'engine_start_time')} placeholder="" />
                      </div>
                      <div className="col-md-6">
                        <button className="btn btn-primary button-inline btn-sm form-control" onClick={() => {this.autoFillTime('engine_start_time', null)}}>
                        <i className="fa fa-calendar-check-o"></i></button>
                      </div>
                    </div>
                  </td>
                  {/* <td>
                    <div className="row">
                      <div className="col-md-6">
                        <InputMask value={this.state.flight_following_engine_start_time} maskChar={null} name="flight_following_engine_start_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'flight_following_engine_start_time')} placeholder="" disabled='disabled' />
                      </div>
                      <div className="col-md-6">
                        <button className="btn btn-success button-inline btn-sm form-control" onClick={() => {this.autoFillTime('engine_start_time', this.state.flight_following_engine_start_time)}}>
                        <i className="fa fa-arrow-circle-o-left"></i></button>
                      </div>
                    </div>
                  </td> */}
                </tr>
              </tbody>
            </table>
          </div>
          <h4>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.DEC}</h4>
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th className="text-center col-md-2">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Horario}</th>
                  {/* <th className="text-center col-md-2">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Following}</th> */}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="row">
                      <div className="col-md-6">
                        <InputMask value={this.state.takeoff_time} style={{minWidth: '63px'}}  maskChar={null} name="takeoff_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'takeoff_time')} placeholder="" />

                      </div>
                      <div className="col-md-6">
                        <button className="btn btn-primary button-inline btn-sm form-control" onClick={() => {this.autoFillTime('takeoff_time', null)}}>
                        <i className="fa fa-calendar-check-o"></i></button>
                      </div>
                    </div>
                  </td>
                  {/* <td className="text-center">
                    <div className="row">
                      <div className="col-md-6">
                        <InputMask value={this.state.flight_following_takeoff_time} style={{minWidth: '63px'}}  maskChar={null} name="flight_following_takeoff_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'flight_following_takeoff_time')} placeholder="" disabled='disabled' />
                      </div>
                      <div className="col-md-6">
                        <button className="btn btn-success button-inline btn-sm form-control" onClick={() => {this.autoFillTime('takeoff_time', this.state.flight_following_takeoff_time)}}>
                        <i className="fa fa-arrow-circle-o-left"></i></button>
                      </div>
                    </div>
                  </td> */}
                </tr>
              </tbody>
            </table>
          </div>
          <h4>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.POU}</h4>
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th className="text-center col-md-2">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Horario}</th>
                  {/* <th className="text-center col-md-2">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Following}</th> */}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="row">
                      <div className="col-md-6">
                        <InputMask value={this.state.landing_time} style={{minWidth: '63px'}}  maskChar={null} name="landing_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'landing_time')} placeholder="" />

                      </div>
                      <div className="col-md-6">
                        <button className="btn btn-primary button-inline btn-sm form-control" onClick={() => {this.autoFillTime('landing_time', null)}}>
                        <i className="fa fa-calendar-check-o"></i></button>
                      </div>
                    </div>
                  </td>
                  {/* <td className="text-center">
                    <div className="row">
                      <div className="col-md-6">
                        <InputMask value={this.state.flight_following_landing_time} style={{minWidth: '63px'}}  maskChar={null} name="flight_following_landing_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'flight_following_landing_time')} placeholder="" disabled='disabled' />
                      </div>
                      <div className="col-md-6">
                        <button className="btn btn-success button-inline btn-sm form-control" onClick={() => {this.autoFillTime('landing_time', this.state.flight_following_landing_time)}}>
                        <i className="fa fa-arrow-circle-o-left"></i></button>
                      </div>
                    </div>
                  </td> */}
                </tr>
              </tbody>
            </table>
          </div>
          <h4>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Corte}</h4>
          <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th className="text-center col-md-2">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Horario}</th>
                  {/* <th className="text-center col-md-2">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Following}</th> */}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="row">
                      <div className="col-md-6">
                        <InputMask value={this.state.engine_shutoff_time} style={{minWidth: '63px'}}  maskChar={null} name="engine_shutoff_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'engine_shutoff_time')} placeholder="" />

                      </div>
                      <div className="col-md-6">
                        <button className="btn btn-primary button-inline btn-sm form-control" onClick={() => {this.autoFillTime('engine_shutoff_time', null)}}>
                        <i className="fa fa-calendar-check-o"></i></button>
                      </div>
                    </div>
                  </td>
                  {/* <td className="text-center">
                    <div className="row">
                      <div className="col-md-6">
                        <InputMask value={this.state.flight_following_engine_shutoff_time} style={{minWidth: '63px'}}  maskChar={null} name="flight_following_engine_shutoff_time" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'flight_following_engine_shutoff_time')} placeholder="" disabled='disabled' />
                      </div>
                      <div className="col-md-6">
                        <button className="btn btn-success button-inline btn-sm form-control" onClick={() => {this.autoFillTime('engine_shutoff_time', this.state.flight_following_engine_shutoff_time)}}>
                        <i className="fa fa-arrow-circle-o-left"></i></button>
                      </div>
                    </div>
                  </td> */}
                </tr>
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={() => {this.setState({modal_flight_following: false})}}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
  </tr>
    );
  }
}

export default FlightReportLegAddTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportLegAddTab.js